import script from "./select-input.vue?vue&type=script&setup=true&lang=js"
export * from "./select-input.vue?vue&type=script&setup=true&lang=js"

import "./select-input.vue?vue&type=style&index=0&id=c3907e9c&scoped=true&lang=postcss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3907e9c"]])

export default __exports__